// extracted by mini-css-extract-plugin
export default {"page_wrapper":"features_page_wrapper__IdcBT"};